import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import { Box, Tooltip, Typography } from "@mui/material";

const COLORS = {
  under: "#55E58C",
  expired: "#E58755",
};

const WarrantyChart = ({ chartData }) => {
  if (!chartData?.WarrantySummary) return null;
  console.log("object", chartData.TotalRevenue);

  const { Under_Warranty, expired_warranty } = chartData.WarrantySummary;

  const data = [
    { name: "Under Warranty", value: Under_Warranty },
    { name: "Expired Warranty", value: expired_warranty },
  ];

  const totalDevices = Under_Warranty + expired_warranty;
  const totalRevenue = chartData?.TotalRevenue
    ?.Total_physical_amount + chartData?.TotalRevenue
      ?.Total_repairing_amount || 0;

  const handleMouseOrTouch = () => {
    setTimeout(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    }, 0);
  };

  if (totalDevices === 0) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height={200}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Public Sans",
            color: "#999999",
            fontWeight: 600,
          }}
        >
          No Data Available
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={"space-around"}
      gap={4}
      sx={{
        "& .recharts-wrapper:focus, & .recharts-responsive-container:focus, & .recharts-surface:focus, & svg:focus, & .recharts-wrapper *:focus": {
          outline: "none !important",
          boxShadow: "none !important",
          border: "none !important",
        },
      }}
      onMouseDown={handleMouseOrTouch}
      onTouchStart={handleMouseOrTouch}
    >
      <Box sx={{ width: 200, height: 200 }}>
        <ResponsiveContainer maxWidth={180} maxHeight={200} width={180} height={180} >
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={55}
              outerRadius={80}
              paddingAngle={2}
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={
                    entry.name === "Under Warranty"
                      ? COLORS.under
                      : COLORS.expired
                  }
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Box>

      <Box
        display={"flex"}
        flexDirection="column"
        gap={2}
        justifyContent={"space-around"}
      >
        <Box>
          <Box mb={2} sx={{ borderLeft: "2px solid #E6E6E6", pl: 2 }}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Public Sans",
                color: "#999999",
                fontWeight: 600,
              }}
            >
              Total Device
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#1D013B",
                fontFamily: "Public Sans",
              }}
            >
              {totalDevices}
            </Typography>
          </Box>

          <Tooltip
            arrow
            placement="top"
            title={
              <Box sx={{ gap:2, p:2, display:"flex", flexDirection:"column", justifyContent:"space-between"}}>
                <Typography variant="body2">
                  Queries: {chartData.TotalRevenue.Total_queries}
                </Typography>
                <Typography variant="body2">
                  Physical Amount: ₹ {chartData.TotalRevenue.Total_physical_amount.toLocaleString()}
                </Typography>
                <Typography variant="body2">
                  Repairing Amount: ₹ {chartData.TotalRevenue.Total_repairing_amount.toLocaleString()}
                </Typography>
              </Box>
            }
          >
            <Box
              mb={2}
              sx={{ borderLeft: "2px solid #E6E6E6", pl: 2, cursor: "pointer" }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "Public Sans",
                  color: "#999999",
                  fontWeight: 600,
                }}
              >
                Total Revenue
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: "#1D013B",
                  fontFamily: "Public Sans",
                }}
              >
                ₹ {totalRevenue.toLocaleString()}
              </Typography>
            </Box>
          </Tooltip>


        </Box>

        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            padding: "8px 12px",
            fontFamily: "Public Sans",
          }}
        >
          <Box display="flex" alignItems="center" mb={1}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: COLORS.under,
                mr: 1,
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: "#4D4D4D",
                fontFamily: "Public Sans",
                fontWeight: 500,
              }}
            >
              Under Warranty ({Under_Warranty})
            </Typography>
          </Box>

          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: COLORS.expired,
                mr: 1,
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: "#4D4D4D",
                fontFamily: "Public Sans",
                fontWeight: 500,
              }}
            >
              Expired Warranty ({expired_warranty})
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WarrantyChart;
